import React from 'react';
import { motion } from 'framer-motion';
export function ForWhoSection() {
  const notFor = ['Buscan soluciones mágicas', 'No aplican lo aprendido', 'Abandonan rápido'];
  const isFor = ['Quieres cambiar de verdad', 'Estás cansado de lo mismo', 'Quieres recuperar control', 'Quieres sentirte seguro'];
  return <section className="relative w-full bg-[#0a0a0a] py-8 md:py-12 overflow-hidden" data-id="element-137">
      <div className="absolute inset-0 z-0" data-id="element-138">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-red-900/10 blur-[150px]" data-id="element-139" />
      </div>

      <div className="relative z-20 max-w-5xl mx-auto px-6" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-141">
          <h2 className="font-display text-3xl md:text-5xl uppercase mb-10 text-center text-white drop-shadow-[0_0_20px_rgba(220,38,38,0.3)]" data-id="element-142">
            <span className="text-red-500" data-id="element-143">⚠️</span> ¿Es para vos?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-144">
            {/* Not For */}
            <div className="relative bg-gradient-to-b from-[#0a0a0a] to-black border border-red-900/40 p-6 rounded-lg" data-id="element-145">
              <h3 className="font-display text-base md:text-lg uppercase mb-4 text-gray-500 tracking-wider" data-id="element-146">
                ✗ NO es para ti si:
              </h3>
              <ul className="space-y-2" data-id="element-147">
                {notFor.map((item, index) => <li key={index} className="text-sm md:text-base text-gray-500 flex items-start gap-2" data-id="element-148">
                    <span className="text-red-900 mt-1" data-id="element-149">✗</span> {item}
                  </li>)}
              </ul>
            </div>

            {/* Is For */}
            <div className="relative bg-gradient-to-b from-[#0a0a0a] to-black border border-red-600/40 p-6 rounded-lg shadow-[0_0_30px_rgba(220,38,38,0.1)] overflow-hidden" data-id="element-150">
              <div className="absolute inset-0 bg-red-600/5 blur-2xl" data-id="element-151" />
              <span className="absolute top-0 left-0 w-5 h-5 border-t-2 border-l-2 border-red-500" data-id="element-152" />
              <span className="absolute top-0 right-0 w-5 h-5 border-t-2 border-r-2 border-red-500" data-id="element-153" />
              <span className="absolute bottom-0 left-0 w-5 h-5 border-b-2 border-l-2 border-red-500" data-id="element-154" />
              <span className="absolute bottom-0 right-0 w-5 h-5 border-b-2 border-r-2 border-red-500" data-id="element-155" />

              <h3 className="relative font-display text-base md:text-lg uppercase mb-4 text-white tracking-wider" data-id="element-156">
                ✔ SÍ es para ti si:
              </h3>
              <ul className="relative space-y-2" data-id="element-157">
                {isFor.map((item, index) => <li key={index} className="text-sm md:text-base text-white flex items-start gap-2 font-medium" data-id="element-158">
                    <span className="text-red-500 mt-1 drop-shadow-[0_0_6px_rgba(220,38,38,0.5)]" data-id="element-159">
                      ✓
                    </span>{' '}
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}